<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { client } from '@/services/client'

export default defineComponent({
  name: 'SSOLoginPage',

  data: () => ({
    redirectUrl: 'https://feedback.storyblok.com/b/feature-requests/',
  }),

  created() {
    this.loadUpvotyToken()
  },

  methods: {
    async loadUpvotyToken() {
      client
        .post('upvoty_tokens', {})
        .then((response) => {
          const token = response.data.token

          const URL = this.getUpvotyUrl(token)

          window.location.href = URL
        })
        .catch((err) => {
          this.$sbnotify.error(err)
        })
    },

    getUpvotyUrl(token) {
      return `https://feedback.storyblok.com/front/handleSSO/${token}/?redirectUrl=${this.redirectUrl}`
    },
  },
})
</script>
